export enum ApiProjectCreationType {
    OFF = 'API_OFF',
    ON = 'API_ON',
    API_CREATION_ONLY = 'API_ONLY',
}
